import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import CursoInteresse from '../components/curso-interesse';





const mapStateToProps = (state, ownProps) => {

    return state.solicitacao.cursoInteresse;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        carregarFinanciamentosdisponiveis: () => {
            dispatch(actions.carregarFinanciamentosdisponiveis());
        },
        onChangeMotivo: (e) =>{
            dispatch(actions.onChangeMotivo(e.target.value));
        },
        onChangePercentDesejado: (e) => {
            dispatch(actions.onChangePercentDesejado(e.target.value));
        },
        onChangeCursoInteresse: (e) => {
            dispatch(actions.changeCurso(e.target.value));
        },
        onChangePeriodo: (e) => {
            dispatch(actions.changePeriodo(e.target.value));
        },
        onChangePolo: (e) => {
            dispatch(actions.changePolo(e.target.value));
        }
    };
};

const CursoInteresseContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CursoInteresse);


export default CursoInteresseContainer;


// WEBPACK FOOTER //
// ./src/containers/curso-interesse.js